import { useLocation, useNavigate } from "react-router";

const useIdNavigate = () => {

  const navigate = useNavigate();  
  const { pathname } = useLocation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
      navigate(`${pathname}#${id}`, { replace: true });
    }
  };

  return { 
    scrollToSection 
  };
}

export default useIdNavigate;